<template>
  <SidePanel
    :isVisible="true"
    @cancel="onCancel"
    :rightCommand="true"    
    @save="onSave"
    :header="header"
    :save="saveText"
    :cancel="cancelText"
    :loading="loading"
  >

    <div v-if="passwordChanged" class="password-changed text-size-18 text-dark-grey m-4 p-3 justify-content-center">
      {{ $t('profile.changePasswordSuccessfully') }}
    </div>
    <div v-else class="sidepanel-body">
      <div class="sidepanel-group">
        <InputTextValidated
          type="password"
          :errors="errorPassword"
          :label="$t('profile.lblPassword')"
          v-model="password"
        />
        <span class="text-danger" v-if="errors.password">
          {{ $t(errors.password[0]) }}
        </span>
      </div>
      <div class="sidepanel-group">
        <InputTextValidated
          type="password"
          :errors="errorNewPassword"
          :label="$t('profile.lblNewPassword')"
          v-model="newPassword"
        />
        <span class="text-danger" v-if="errors.newPassword">
          {{ $t(errors.newPassword[0]) }}
        </span>        
      </div>
    </div>
  </SidePanel>
</template>

<script>
import SidePanel from '@/components/Rendering/SidePanel.vue';

import { HTTP } from '@/shared/http';
import { formValidationMixin } from '@/components/mixins/FormValidationMixin.js';

export default {
  name: 'EditPassword',
  mixins: [formValidationMixin],
  //  props: ['options'],

  components: {
    SidePanel,
  },

  data() {
    return {
      password: null,
      newPassword: null,
      locale: { code: 'de', label: 'German' },
      errors: [],
      loading: false,
      passwordChanged: false
    };
  },

  computed: {
    errorPassword() {
      if (this.errors.password) {
        return this.errors.password[0];
      }
      return null;
    },

    errorNewPassword() {
      if (this.errors.newPassword) {
        return this.errors.newPassword[0];
      }
      return null;
    },

    header() {
      return this.$t('profile.titlePassword');
    },

    saveText() {
      return this.$t('profile.dlgSave');
    },

    cancelText() {
      return this.$t('profile.dlgCancel');
    },
  },

  methods: {
    onCancel() {
      this.passwordChanged = false;
      this.$emit('close', 'edit-profile');
    },
    onSave() {
      this.clearErrors();
      if (!this.validatePassword(this.newPassword)) return;
      let data = { password: this.password, newPassword: this.newPassword };
      this.loading = true;
      HTTP.put('/api/user/password', data)
        .then((response) => {
          this.loading = false;
          console.log('HTTP Post /api/user response:', response.data);
          if (response.data.errors) {
            this.errors = response.data.errors;
            return;
          }
          this.passwordChanged = true;
          //this.$emit('close');
        })
        .catch((error) => {
          this.loading = false;          
          console.log({ error });
        });
    },
    onChangePassword() {
      console.log('onChangePassword');
    },
  },

  created() {
    this.newUser = {};
    this.newUser = this.user;
  },

  mounted() {},
};
</script>

<style lang="scss">
@import '@/styles/colors.scss';

.separator {
  box-shadow: 0px 1px 0px #e3e3e3;
  height: 5px;
}

.chnage-pwd {
  color: $primary;
}

.password-changed {
  display: flex;
  flex-grow: 1;
}
</style>
